import React, { useState } from 'react';
import ContainerComponent from '../../helpers/components/container.component';
import { useLocation } from 'react-router-dom';
import ActivityListingLayout from "./components/activity_layout";

const CustomerReport = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [filter, setFilter] = useState(() => {
        const rawTransactionTypeIds = queryParams.get("transaction_types"); // e.g., "1,4,5"

        const transaction_type_ids = rawTransactionTypeIds
            ? rawTransactionTypeIds.split(',')                  // → ["1", "4", "5"]
                .map(id => parseInt(id))                 // → [1, 4, 5]
                .filter(id => !isNaN(id))                // remove invalid values
            : [];

        return {
            transaction_types: transaction_type_ids.length > 0 ? transaction_type_ids : null,
            start_date : queryParams.get("start_date"),
            end_date : queryParams.get("end_date"),
        };
    });

    return (
        <>
            <ContainerComponent span={22} top={20} bottom={20}>
                <ActivityListingLayout default_filter={filter} />
            </ContainerComponent>
        </>
    );
}

export default CustomerReport;